/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { DatePickerField, DatePickerFieldProps } from 'ui';
import { LocalDate } from 'js-joda';
import {
  checkFormHasError,
  getFormHelperText,
  handleChangeFormFieldValue,
} from '@tock/shared/ui/forms/formHelpers';
import { useField, useFormikContext } from 'formik';

function FormDatePickerField({
  helperText,
  PopoverProps,
  DatePickerProps,
  onChange,
  onBlur,
  ...rest
}: DatePickerFieldProps) {
  const [field, meta] = useField(rest as any);
  const [clicked, setClicked] = React.useState(false);
  const formikContext = useFormikContext();

  const handleChange = (date: LocalDate) => {
    handleChangeFormFieldValue(field, formikContext, date, onChange as any);
  };

  const handleBlur = (event: React.FocusEvent<any>) => {
    const shouldValidate = clicked ? meta.touched : true;
    formikContext.setFieldTouched(field.name, true, shouldValidate);
  };

  const handleClick = (event: React.MouseEvent<any>) => {
    setClicked(true);
  };

  const hasError = checkFormHasError(meta);

  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  return (
    <DatePickerField
      id={rest.id ?? rest.name}
      error={hasError}
      helperText={helperTextValue as string}
      {...field}
      {...rest}
      onChange={handleChange}
      onClick={handleClick}
      onBlur={handleBlur}
      DatePickerProps={{ ...DatePickerProps }}
      PopoverProps={{ ...PopoverProps }}
    />
  );
}

export default FormDatePickerField;
